import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_CAMPAIGNS,
    SG_GET_CAMPAIGNS,
    FETCH_CAMPAIGN,
    SG_FETCH_CAMPAIGN,
    UPDATE_CAMPAIGN,
    SG_UPDATE_CAMPAIGN,
    DELETE_CAMPAIGN,
    SG_DELETE_CAMPAIGN,
} from "constants/actions";

/* Campaigns */

/* Campaigns */
function* loadCampaigns(action) {
    try {
        const json = yield call(api.GET_CAMPAIGNS, action.payload);
        yield put({ type: GET_CAMPAIGNS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* campaignsLoad() {
    yield takeLatest(SG_GET_CAMPAIGNS, loadCampaigns);
}

function* fetchCampaign(action) {
    try {
        const json = yield call(api.FETCH_CAMPAIGN, action.payload);
        yield put({ type: FETCH_CAMPAIGN, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* campaignFetch() {
    yield takeLatest(SG_FETCH_CAMPAIGN, fetchCampaign);
}

function* updateCampaign(action) {
    try {
        const json = yield call(api.EDIT_CAMPAIGN, action.payload);
        yield put({ type: UPDATE_CAMPAIGN, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* campaignUpdate() {
    yield takeLatest(SG_UPDATE_CAMPAIGN, updateCampaign);
}

function* deleteCampaign(action) {
    try {
        const json = yield call(api.DELETE_CAMPAIGN, action.payload);
        yield put({ type: DELETE_CAMPAIGN, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* campaignDelete() {
    yield takeLatest(SG_DELETE_CAMPAIGN, deleteCampaign);
}

export default function* index() {
    yield all([
    campaignsLoad(),
    campaignFetch(),
    campaignUpdate(),
    campaignDelete(),
    ]);
}
